var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3646 2.63668C11.849 -0.878894 6.15226 -0.878894 2.63668 2.63668C-0.878894 6.15226 -0.878894 11.849 2.63668 15.3646C6.15226 18.8802 11.849 18.8802 15.3646 15.3646C18.8802 11.849 18.8802 6.15226 15.3646 2.63668ZM11.9773 13.4144C11.808 13.5837 11.5308 13.5837 11.3615 13.4144L9.00064 11.0535L6.63982 13.4144C6.47045 13.5837 6.19332 13.5837 6.02395 13.4144L4.58693 11.9773C4.41756 11.808 4.41756 11.5308 4.58693 11.3615L6.94775 9.00064L4.58693 6.63982C4.41756 6.47045 4.41756 6.19331 4.58693 6.02395L6.02395 4.58693C6.19331 4.41756 6.47045 4.41756 6.63982 4.58693L9.00064 6.94775L11.3615 4.58693C11.5308 4.41756 11.808 4.41756 11.9773 4.58693L13.4144 6.02395C13.5837 6.19331 13.5837 6.47045 13.4144 6.63982L11.0535 9.00064L13.4144 11.3615C13.5837 11.5308 13.5837 11.808 13.4144 11.9773L11.9773 13.4144Z",
    fill: "#E2E7E9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNone);
export default __webpack_public_path__ + "static/media/none.947a483c309a6827829ca7c443773921.svg";
export { ForwardRef as ReactComponent };